import {formatNumber} from '@angular/common';
import {inject, Pipe, PipeTransform} from '@angular/core';
import {TranslocoService} from '@jsverse/transloco';

export function formatAppNumber(
  value: number | null | undefined,
  locale: string,
  digitsInfo?: string,
): string {
  if (value === null || value === undefined || Number.isNaN(value)) {
    return '';
  }
  return formatNumber(value, locale, digitsInfo);
}

@Pipe({
  name: 'appNumber',
})
export class AppNumberPipe implements PipeTransform {
  private readonly translocoService = inject(TranslocoService);

  transform(value: number | null | undefined, digitsInfo?: string): string {
    return formatAppNumber(value, this.translocoService.getActiveLang(), digitsInfo);
  }
}
